import {IServiceFactory} from '../../service-factory.interface';
import {CmsLink} from './cms-link';
import {Check} from '@sparkware/app-utils';
import {evaluateScripts} from "./evaluate-scripts";

export class CmsContentDecorator {
  constructor(private _element: HTMLElement, private services: IServiceFactory ) {
    this._evaluateScripts();
    this._loadCmsLinks();
  }

  private _cmsLinks: CmsLink[] = [];


  dispose() {
    this._cmsLinks.forEach(a => a.dispose());
  }


  private _evaluateScripts() {
    evaluateScripts(this._element.innerHTML);
  }


  private _loadCmsLinks() {
    let linkTags = this._element.getElementsByTagName('a');
    for(let i = 0; i < linkTags.length; i++) {
      let currentLink = linkTags[i] as HTMLAnchorElement;
      if (Check.isEmpty(currentLink.href) || currentLink.target === '_blank') {
        continue;
      }

      let anchorUri = this.services.location.tryParseUrl(currentLink.href);
      if(!anchorUri) {
        continue;
      }

      if(anchorUri.origin === this.services.location.currentUri.origin) {
        this._cmsLinks.push(new CmsLink(currentLink, this._element, this.services));
      }

    }
  }

  scrollIntoView(childElementSelector: string): void {
    try {
      let el = this._element.querySelector(childElementSelector);
      if(el) {
        el.scrollIntoView();
      }
    } catch (err) {
      this.services.logger.error(`Failed to scroll into view element with id ${childElementSelector}`, err);
    }

  }
}
